module.exports = __webpack_public_path__ + "img/invitation_process@2x.f0a278d4.png";